import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';

export default function GovtSchemesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              <span className="text-orange-600">Government Schemes</span>
            </h1>
            <p className="text-xl text-gray-600">
              Government-backed investment and savings schemes for financial security
            </p>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {/* Introduction */}
            <section className="bg-orange-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Why Government Schemes?</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Government schemes offer safe, guaranteed returns with sovereign backing. These schemes 
                are designed for various financial goals including retirement, children's education, 
                and long-term savings with attractive tax benefits.
              </p>
              <div className="bg-white rounded-xl p-6 border-2 border-orange-200">
                <h3 className="font-bold text-lg mb-3">🏛️ Key Benefits:</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• 100% safe with government guarantee</li>
                  <li>• Attractive interest rates</li>
                  <li>• Tax benefits under various sections</li>
                  <li>• Suitable for all age groups</li>
                </ul>
              </div>
            </section>

            {/* Popular Schemes */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Popular Government Schemes</h2>
              <div className="grid gap-6">
                {/* PPF */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Public Provident Fund (PPF)</h3>
                  <p className="text-gray-600 mb-3">
                    Long-term savings scheme with tax-free returns. 15-year lock-in with partial withdrawal after 5 years.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Interest Rate:</span>
                      <span className="font-bold text-orange-700 ml-2">7.1% p.a.*</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Tax Benefit:</span>
                      <span className="font-bold text-green-700 ml-2">Section 80C</span>
                    </div>
                  </div>
                </div>

                {/* SCSS */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Senior Citizen Savings Scheme (SCSS)</h3>
                  <p className="text-gray-600 mb-3">
                    Ideal for retirees above 60 years. Provides regular quarterly interest income with safety.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Interest Rate:</span>
                      <span className="font-bold text-orange-700 ml-2">8.2% p.a.*</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Age Limit:</span>
                      <span className="font-bold text-blue-700 ml-2">60+ years</span>
                    </div>
                  </div>
                </div>

                {/* Sukanya Samriddhi */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Sukanya Samriddhi Yojana (SSY)</h3>
                  <p className="text-gray-600 mb-3">
                    For girl child education and marriage. Highest interest rate among government schemes with complete tax exemption.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Interest Rate:</span>
                      <span className="font-bold text-orange-700 ml-2">8.0% p.a.*</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Maturity:</span>
                      <span className="font-bold text-purple-700 ml-2">21 years</span>
                    </div>
                  </div>
                </div>

                {/* NSC */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">National Savings Certificate (NSC)</h3>
                  <p className="text-gray-600 mb-3">
                    Fixed income investment with 5-year lock-in. Good for tax planning under Section 80C.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Interest Rate:</span>
                      <span className="font-bold text-orange-700 ml-2">7.7% p.a.*</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Tenure:</span>
                      <span className="font-bold text-indigo-700 ml-2">5 years</span>
                    </div>
                  </div>
                </div>

                {/* APY */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Atal Pension Yojana (APY)</h3>
                  <p className="text-gray-600 mb-3">
                    Pension scheme for unorganized sector. Guaranteed minimum pension of ₹1,000-5,000 per month.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Age:</span>
                      <span className="font-bold text-orange-700 ml-2">18-40 years</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Pension Starts:</span>
                      <span className="font-bold text-green-700 ml-2">At 60 years</span>
                    </div>
                  </div>
                </div>

                {/* Post Office Schemes */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Post Office Monthly Income Scheme (POMIS)</h3>
                  <p className="text-gray-600 mb-3">
                    Regular monthly income with government backing. Safe investment for conservative investors.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Interest Rate:</span>
                      <span className="font-bold text-orange-700 ml-2">7.4% p.a.*</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Tenure:</span>
                      <span className="font-bold text-teal-700 ml-2">5 years</span>
                    </div>
                  </div>
                </div>

                {/* NPS */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">National Pension System (NPS)</h3>
                  <p className="text-gray-600 mb-3">
                    Market-linked retirement savings scheme with tax benefits. Flexible investment options with choice of fund managers.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Age:</span>
                      <span className="font-bold text-orange-700 ml-2">18-70 years</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Tax Benefit:</span>
                      <span className="font-bold text-green-700 ml-2">Up to ₹2L (80C+80CCD)</span>
                    </div>
                  </div>
                </div>

                {/* VPF */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Voluntary Provident Fund (VPF)</h3>
                  <p className="text-gray-600 mb-3">
                    Extension of EPF allowing salaried employees to contribute more than mandatory 12%. Risk-free returns with EEE tax benefit.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Interest Rate:</span>
                      <span className="font-bold text-orange-700 ml-2">8.25% p.a.*</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Tax Benefit:</span>
                      <span className="font-bold text-green-700 ml-2">EEE (Exempt-Exempt-Exempt)</span>
                    </div>
                  </div>
                </div>

                {/* PM-SYM */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Pradhan Mantri Shram Yogi Maan-dhan (PM-SYM)</h3>
                  <p className="text-gray-600 mb-3">
                    Pension scheme for unorganized workers earning up to ₹15,000/month. Guaranteed minimum pension of ₹3,000 per month after 60.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Age:</span>
                      <span className="font-bold text-orange-700 ml-2">18-40 years</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Pension:</span>
                      <span className="font-bold text-green-700 ml-2">₹3,000/month</span>
                    </div>
                  </div>
                </div>

                {/* PM-KISAN */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Pradhan Mantri Kisan Samman Nidhi (PM-KISAN)</h3>
                  <p className="text-gray-600 mb-3">
                    Income support for farmers. Direct cash transfer of ₹6,000 per year in three equal installments to all farmer families.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Benefit:</span>
                      <span className="font-bold text-orange-700 ml-2">₹6,000/year</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Eligibility:</span>
                      <span className="font-bold text-green-700 ml-2">All farmer families</span>
                    </div>
                  </div>
                </div>

                {/* PM-JJBY */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Pradhan Mantri Jeevan Jyoti Bima Yojana (PM-JJBY)</h3>
                  <p className="text-gray-600 mb-3">
                    Life insurance scheme providing ₹2 lakh coverage on death. Annual premium of just ₹436 auto-debited from bank account.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Coverage:</span>
                      <span className="font-bold text-orange-700 ml-2">₹2 Lakh</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Premium:</span>
                      <span className="font-bold text-blue-700 ml-2">₹436/year</span>
                    </div>
                  </div>
                </div>

                {/* PM-SBY */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Pradhan Mantri Suraksha Bima Yojana (PM-SBY)</h3>
                  <p className="text-gray-600 mb-3">
                    Accident insurance providing ₹2 lakh on accidental death/total disability. Premium of only ₹20 per year.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Coverage:</span>
                      <span className="font-bold text-orange-700 ml-2">₹2 Lakh (Death/Disability)</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Premium:</span>
                      <span className="font-bold text-blue-700 ml-2">₹20/year</span>
                    </div>
                  </div>
                </div>

                {/* PM-JAY */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Pradhan Mantri Jan Arogya Yojana (PM-JAY)</h3>
                  <p className="text-gray-600 mb-3">
                    World's largest health insurance scheme (Ayushman Bharat). Provides health cover of ₹5 lakh per family per year for secondary and tertiary care.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Coverage:</span>
                      <span className="font-bold text-orange-700 ml-2">₹5 Lakh/family/year</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Eligibility:</span>
                      <span className="font-bold text-green-700 ml-2">Economically vulnerable families</span>
                    </div>
                  </div>
                </div>

                {/* ABDM */}
                <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-orange-300 transition-colors">
                  <h3 className="font-bold text-lg mb-2 text-orange-600">Ayushman Bharat Digital Mission (ABDM)</h3>
                  <p className="text-gray-600 mb-3">
                    Digital health ecosystem creating unique health IDs for citizens. Enables digital access to health records and seamless healthcare services.
                  </p>
                  <div className="grid md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Benefit:</span>
                      <span className="font-bold text-orange-700 ml-2">Digital Health ID</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded">
                      <span className="text-gray-600">Feature:</span>
                      <span className="font-bold text-purple-700 ml-2">Paperless health records</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Comparison */}
            <section className="bg-gradient-to-r from-orange-50 to-yellow-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">How to Choose?</h2>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-xl mr-2">💰</span>
                  <span className="text-gray-700"><strong>For Retirement:</strong> PPF, SCSS, APY, NPS, PM-SYM, VPF</span>
                </li>
                <li className="flex items-start">
                  <span className="text-xl mr-2">👧</span>
                  <span className="text-gray-700"><strong>For Girl Child:</strong> Sukanya Samriddhi Yojana</span>
                </li>
                <li className="flex items-start">
                  <span className="text-xl mr-2">🎯</span>
                  <span className="text-gray-700"><strong>For Regular Income:</strong> POMIS, SCSS</span>
                </li>
                <li className="flex items-start">
                  <span className="text-xl mr-2">💼</span>
                  <span className="text-gray-700"><strong>For Tax Saving:</strong> PPF, NSC, SSY, NPS, VPF</span>
                </li>
                <li className="flex items-start">
                  <span className="text-xl mr-2">🏥</span>
                  <span className="text-gray-700"><strong>For Health Coverage:</strong> PM-JAY, ABDM</span>
                </li>
                <li className="flex items-start">
                  <span className="text-xl mr-2">🛡️</span>
                  <span className="text-gray-700"><strong>For Insurance:</strong> PM-JJBY (Life), PM-SBY (Accident)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-xl mr-2">🌾</span>
                  <span className="text-gray-700"><strong>For Farmers:</strong> PM-KISAN</span>
                </li>
              </ul>
            </section>

            {/* Disclaimer */}
            <section className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded">
              <p className="text-sm text-gray-700">
                <strong>*Note:</strong> Interest rates are subject to change quarterly/annually by the Government of India. 
                Consult with K Satish for current rates and personalized recommendations based on your financial goals.
              </p>
            </section>

            {/* CTA */}
            <section className="text-center bg-orange-600 text-white rounded-2xl p-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">
                Choose the Right Government Scheme
              </h2>
              <p className="text-orange-100 mb-6">
                Get expert guidance on which government schemes suit your financial goals
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/#contact"
                  className="inline-block bg-white text-orange-700 px-8 py-4 rounded-xl hover:bg-gray-50 transition-all shadow-lg font-semibold"
                >
                  Get Free Consultation
                </Link>
                <a
                  href="https://wa.me/919248852187?text=Hi, I want to know about Government Savings Schemes"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-green-500 text-white px-8 py-4 rounded-xl hover:bg-green-600 transition-all shadow-lg font-semibold"
                >
                  WhatsApp Now
                </a>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
